import React from 'react';

const cx = (...v) => v.filter(Boolean).join(' ');

export default function Stepper({ steps = [], currentStep = 1, className = '' }) {
  return (
    <div className={cx('grid grid-cols-3 gap-2', className)}>
      {steps.map((step) => {
        const active = step.id === currentStep;
        const done = step.id < currentStep;
        return (
          <div
            key={step.id}
            className={cx(
              'rounded-xl px-3 py-2',
              active && 'bg-[rgba(55,242,135,0.18)]',
              done && 'bg-[rgba(146,155,250,0.18)]',
              !active && !done && 'bg-[rgba(15,24,38,0.82)]'
            )}
          >
            <p className="text-[10px] font-semibold uppercase tracking-[0.12em] text-[#7f93ac]">
              Langkah {step.id}
            </p>
            <p className={cx('text-sm font-semibold', active || done ? 'text-[#e7f0fa]' : 'text-[#93a8c1]')}>
              {step.title}
            </p>
          </div>
        );
      })}
    </div>
  );
}
